import { darkTheme } from './darkTheme';

/**
 * Default theme in the application
 */
export const defaultTheme = darkTheme;
